import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { convertButtonProps } from "abreact/misc/AbButton";
import { AbToggleButton as AbToggleButtonInternal } from "abreact/misc/AbToggleButton";
import * as React from "react";

/**
 * The properties for an **AbToggleButton**.
 */

/**
 * The **AbToggleButton** component allows the user to toggle a value on and off.
 *
 * [[include:absdk/commons/ui/misc/AbToggleButton.md]]
 */
export function AbToggleButton(props) {
  return /*#__PURE__*/React.createElement(AbToggleButtonInternal, _extends({}, convertButtonProps(props), {
    value: props.value,
    onChange: props.onChange
  }));
}
//# sourceMappingURL=AbToggleButton.js.map
